export default __webpack_public_path__ + "static/media/santhosh.6f6bed23.png";